import { BallotState, __BallotState } from './ballot-state'

// ----------------------------------------------------------------------------
// FederalBallotState
//
// An extension to BallotState which also includes information about whether
// the majority of cantons accepted or rejected the ballot (in cases when such
// a majority is required for the ballot to pass).

export interface FederalBallotState {
  ballotState: BallotState
  majorityOfCantons: MajorityOfCantonsVote
}

export type MajorityOfCantonsVote = 'notRequired' | 'undecided' | 'reject' | 'accept'

export const mkFederalBallotState = (x: FederalBallotState): FederalBallotState => x

export const mkMajorityOfCantonsVote = (x: MajorityOfCantonsVote): MajorityOfCantonsVote => x

export interface MajorityOfCantonsVoteMatcher<T> {
  notRequired: T
  undecided: T
  reject: T
  accept: T
}

export const caseMajorityOfCantonsVote =
  <T>(m: MajorityOfCantonsVoteMatcher<T>) =>
  (moc: MajorityOfCantonsVote): T =>
    m[moc]

// ----------------------------------------------------------------------------
// Catalog

export const __FederalBallotState = {
  pre: mkFederalBallotState({
    ballotState: __BallotState.pre,
    majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
  }),
  inProgress: mkFederalBallotState({
    ballotState: __BallotState.inProgress,
    majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
  }),
  trend: {
    yea: mkFederalBallotState({
      ballotState: __BallotState.trend.yea,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
    nay: mkFederalBallotState({
      ballotState: __BallotState.trend.nay,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
  },
  projection: {
    yea: mkFederalBallotState({
      ballotState: __BallotState.projection.yea,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
    nay: mkFederalBallotState({
      ballotState: __BallotState.projection.nay,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
  },
  finalResult: {
    yea: mkFederalBallotState({
      ballotState: __BallotState.finalResult.yea,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
    yeaWithGap: mkFederalBallotState({
      ballotState: __BallotState.finalResult.yeaWithGap,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
    nay: mkFederalBallotState({
      ballotState: __BallotState.finalResult.nay,
      majorityOfCantons: mkMajorityOfCantonsVote('notRequired'),
    }),
  },
  majorityOfCantonsReject: {
    pre: mkFederalBallotState({
      ballotState: __BallotState.pre,
      majorityOfCantons: mkMajorityOfCantonsVote('reject'),
    }),
    yea: mkFederalBallotState({
      ballotState: __BallotState.projection.yea,
      majorityOfCantons: mkMajorityOfCantonsVote('reject'),
    }),
    nay: mkFederalBallotState({
      ballotState: __BallotState.projection.nay,
      majorityOfCantons: mkMajorityOfCantonsVote('reject'),
    }),
    finalResultNay: mkFederalBallotState({
      ballotState: __BallotState.finalResult.nay,
      majorityOfCantons: mkMajorityOfCantonsVote('reject'),
    }),
  },
}
